import { render, staticRenderFns } from "./webNewsList.vue?vue&type=template&id=71321fb0&scoped=true&"
import script from "./webNewsList.vue?vue&type=script&lang=js&"
export * from "./webNewsList.vue?vue&type=script&lang=js&"
import style0 from "./webNewsList.vue?vue&type=style&index=0&id=71321fb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71321fb0",
  null
  
)

export default component.exports